import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

export class CustomDateRangePicker {
  latestDataAvailableDay = moment().subtract(2, 'day');
  maxDate: moment.Moment;
  minDate: moment.Moment;
  selected: { startDate: moment.Moment, endDate: moment.Moment };
  locale: any;

  ranges: any = {
    'Last Available Day': [this.latestDataAvailableDay, this.latestDataAvailableDay],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Month to Date': [moment().startOf('month'), this.latestDataAvailableDay],
    'Quarter to Date': [moment().startOf('quarter'), this.latestDataAvailableDay],
    'Year to Date': [moment().startOf('year'), this.latestDataAvailableDay],
    '365 days': [moment(this.latestDataAvailableDay).subtract(1, 'year'), this.latestDataAvailableDay]
  }

  constructor(private translate: TranslateService) {
    this.maxDate = moment().subtract(2, 'day');
    this.minDate = moment('01-07-2018', 'DD-MM-YYYY');
    this.selected = {
      startDate: moment().subtract(1, 'month'),
      endDate: this.maxDate
    }
    this.handleCalendarTranslation();
  }

  private handleCalendarTranslation() {
    this.translate.onLangChange.subscribe(event => {
      this.changeLocale(event.lang);
    });
  }

  changeLocale(language: string) {
    moment.locale(language);
    this.renameRangeLabels(language);
    this.locale = {
      format: 'MMMM DD, YYYY',
      customRangeLabel: this.translate.instant('calendar.custom-range'),
      clearLabel: this.translate.instant('calendar.clear'),
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort()
    }
  }

  private renameRangeLabels(language: string) {
    if (language === "en_US") {
      this.ranges = {
        'Last Available Day': [this.latestDataAvailableDay, this.latestDataAvailableDay],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Month to Date': [moment().startOf('month'), this.latestDataAvailableDay],
        'Quarter to Date': [moment().startOf('quarter'), this.latestDataAvailableDay],
        'Year to Date': [moment().startOf('year'), this.latestDataAvailableDay],
        '365 days': [moment(this.latestDataAvailableDay).subtract(1, 'year'), this.latestDataAvailableDay]
      };
    } else if (language === "nl_NL") {
      this.ranges = {
        'Laatst Beschikbare Dag': [this.latestDataAvailableDay, this.latestDataAvailableDay],
        'Vorige Maand': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Maand tot op Heden': [moment().startOf('month'), this.latestDataAvailableDay],
        'Kwartaal tot op Heden': [moment().startOf('quarter'), this.latestDataAvailableDay],
        'Jaar tot op Heden': [moment().startOf('year'), this.latestDataAvailableDay],
        '365 dagen': [moment(this.latestDataAvailableDay).subtract(1, 'year'), this.latestDataAvailableDay]
      };
    }
  }
}
